var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScissors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 80 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0398 -0.0047485C5.73254 3.01129 4.59742 9.00793 7.61344 13.316L23.1238 35.4676L17.4831 43.5224C12.305 40.5232 5.6043 41.934 2.10818 46.9276C-1.58299 52.2009 -0.30203 59.4664 4.9702 63.1591C10.2427 66.8502 17.5097 65.5702 21.2024 60.2968C23.736 56.6782 23.9259 52.1203 22.0925 48.4242L29.0002 38.5584L35.9071 48.4233C34.0746 52.1194 34.2645 56.6771 36.7972 60.2959C40.4899 65.569 47.7562 66.8491 53.0285 63.1582C58.3016 59.4654 59.5826 52.1992 55.8914 46.9268C52.3953 41.9338 45.6946 40.5233 40.5165 43.5217L34.8758 35.4668L50.3852 13.3161C53.4022 9.00804 52.2663 3.01141 47.9588 -0.00463018L29.0001 27.0745L10.0398 -0.0047485ZM17.7226 53.5865C17.7226 56.9231 15.0175 59.6283 11.6808 59.6283C8.3442 59.6283 5.63911 56.923 5.63911 53.5865C5.63911 50.2491 8.34419 47.5447 11.6808 47.5447C15.0175 47.5447 17.7226 50.2491 17.7226 53.5865ZM52.3618 53.5865C52.3618 56.9231 49.6567 59.6282 46.32 59.6282C42.9834 59.6282 40.2783 56.9231 40.2783 53.5865C40.2783 50.2491 42.9834 47.5447 46.32 47.5447C49.6566 47.5447 52.3618 50.249 52.3618 53.5865Z",
    fill: "#008FDD",
    transform: "translate(10 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissors);
export default __webpack_public_path__ + "static/media/scissors.1cc45c4ca24757f3f08204ac284d4c4f.svg";
export { ForwardRef as ReactComponent };